/* RESPONSIBLE TEAM: team-inbox */
import ApplicationAdapter from 'embercom/adapters/application';

export default ApplicationAdapter.extend({
  coalesceFindRequests: true,
});
